module.exports = __webpack_public_path__ + "img/banner.bdf3fa30.jpg";